<template>
  <el-form
    ref="commentForm"
    :model="formData"
    :rules="rules"
    label-position="top"
    v-loading="creating"
  >
    <el-form-item prop="text" label="">
      <el-input type="textarea" v-model.lazy="formData.text" placeholder="Enter your comment..."></el-input>
    </el-form-item>
    <div v-if="showButton">
      <el-button type="primary" @click="submitForm()" :loading="creating">{{ $t('buttons.submit') }}</el-button>
    </div>
  </el-form>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import validations from '@/utils/validations';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'CommentForm',
    props: {
      id: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      showButton: {
        type: Boolean,
        default: true,
      },
      onSubmit: {
        type: Function,
      },
      scrollToBottom: {
        type: Function,
      },
    },
    data() {
      return {
        formData: {
          text: '',
        },
        rules: {
          text: [
            { ...validations.required },
          ],
        },
      };
    },
    computed: {
      ...mapGetters('entities/comments', ['creating']),
    },
    methods: {
      ...mapActions('entities/comments', ['createComment']),

      submitForm() {
        this.$refs.commentForm.validate((valid) => {
          if (valid) {
            if (this.onSubmit) {
              this.onSubmit({ ...this.formData, commentable_id: this.id, commentable_type: this.type });
            } else {
              this.createComment({ ...this.formData, commentable_id: this.id, commentable_type: this.type })
                .then((response) => {
                  if (response.status) {
                    showSuccessMessage('Comment has been added successfully');
                    this.clearForm();
                    this.scrollToBottom();
                  } else {
                    showErrorMessage(response.error);
                  }
                });
            }
          } else {
            showErrorMessage(this.$t('form.messages.notValid'));

            return false;
          }

          return true;
        });
      },

      clearForm() {
        this.$refs.commentForm.resetFields();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/comment/CommentForm.vue